function createSerialIdProvider(): () => string {
	let idCounter = 0;
	return function () {
		return `${idCounter++}`;
	};
}

export default createSerialIdProvider;
